// extracted by mini-css-extract-plugin
export default {"label":"AmountInput_label__PC6Dz","inputContainer":"AmountInput_inputContainer__KKQjp","input":"AmountInput_input__PZZE-"};